import { Package } from './package';
import AddressHelpers, { Address, AddressTypePickup, AddressTypeConsultantToDeliver } from './address';
import CompanyDetailsHelpers, { CompanyDetails } from './companyDetails';
import { Friend } from './friend';
import { BillingAccount } from './billingAccount';
import { Account } from './account';

export interface Order {
  object_type?: string;
  id?: number;
  state?: string;
  reference?: string;
  currency?: string;
  region?: string;
  exchange_rate?: number;
  billing_address?: Address;
  delivery_address?: Address;
  packages: Package[];
  contact_details?: ContactDetails;
  company_details?: CompanyDetails;
  is_valid?: boolean;
  card_id?: null;
  updated_by?: null;
  account_id?: number;
  account?: Account;
  billing_account_id?: number;
  billing_account?: BillingAccount;
  payment_method_id?: null;
  account_invoices?: null;
  total?: number;
  total_tax?: null;
  discount?: null;
  created_at?: string;
  updated_at?: string;
  friends?: Friend[];

  sales_agent_id?: number;
  total_estimated?: number;
  currency_estimated?: string;

  notes?: string;
  lead_source?: string;
  lead_notes?: string;
  invoice_notes?: string;
  release_without_payment?: boolean;
  purchase_order_reference?: string;
  requested_due_date?: number;
  payment_due_date?: number;

  service_matrix_id?: number;

  send_billing_account_emails?: boolean;
  send_hearx_account_emails?: boolean;
}

export interface ContactDetails {
  name: string;
  number: string;
}

function New(): Order {
  return {
    account_id: 0,
    currency: 'ZAR',
    currency_estimated: 'ZAR',
    packages: [],
    billing_address: AddressHelpers.New(),
    delivery_address: AddressHelpers.New(),
    company_details: CompanyDetailsHelpers.New(),
    send_billing_account_emails: true,
    send_hearx_account_emails: true,
  };
}
function ReadOnly(o?: Order) {
  if (!o) { return true; }
  return ["", "DRAFT", "DECLINED"].indexOf(o.state || '') === -1;
}
function HasServiceMatrix(o?: Order) {
  if (!o) { return false; }
  return o.service_matrix_id ? true : false;
}
function HasAccount(o?: Order) {
  if (!o) { return false; }
  return o.account_id ? true : false;
}
function HasPackages(o?: Order) {
  if (!o) { return false; }
  return o.packages.length ? true : false;
}
function HasRegion(o?: Order) {
  if (!o) { return false; }
  return o.region ? true : false;
}
function NeedShippingAddress(o?: Order) { // returns true if any package needs to be shipped
  if (!o) { return true; }
  return o.packages.find((p: any) => p.shippable)
    ? true
    : false;
}
function HasShippingAddress(o?: Order) {
  if (!o || !o.delivery_address) { return false; }
  if (
    o.delivery_address.type === AddressTypePickup ||
    o.delivery_address.type === AddressTypeConsultantToDeliver
  ) { return true; }
  return AddressHelpers.Valid(o.delivery_address);
}
function NeedShippingPackage(o?: Order) {
  if (!o) { return true; }
  if ( // ont type pickup or consultant to deliver, no need for shipping package
    o.delivery_address && (
      o.delivery_address.type === AddressTypePickup ||
      o.delivery_address.type === AddressTypeConsultantToDeliver
    )
  ) { return false; }
  return !!o.packages.find((p: any) => {
    // console.log("p.code: ",p.code,"p.shippable:", p.shippable, "budle:", p.bundle_id, "");
    return p.shippable && ( // find a package that needs shipping
      p.bundle_id // that is not part of a bundle, or
        ? !o.packages.find((ps) => ps.bundle_id == p.bundle_id && ps.category == 'shipping') // is part of a bundle but the bundle doesn't have shipping
        : true
    )
  });
}
function HasShippingPackage(o?: Order) { // returns true if a shipping package was added that is not part of a bundle
  if (!o) { return false; }
  return !!o.packages.find((p: any) => p.category === "shipping" && !p.bundle_id);
}
function HasBillingAddress(o?: Order) {
  if (!o || !o.billing_address) { return false; }
  return AddressHelpers.Valid(o.billing_address);
}
function ConfirmationInfoComplete(o?: Order) {
  if (!o) { return false; }
  if (!o.notes || !o.lead_source || !o.lead_notes) {
    return false;
  }

  // if released without payment, purchase order reference is required
  if (o.release_without_payment && !o.purchase_order_reference) {
    return false;
  }
  return true;
}
function NeedsApproval(o?: Order) {
  if (!o) { return true; }
  if (o.release_without_payment || o.discount) { return true; }
  if (o.packages.find((p) => p.category === "custom")) { return true; }

  return false;
}
export default {
  New,
  ReadOnly,
  HasServiceMatrix,
  HasAccount,
  HasPackages,
  HasRegion,
  NeedShippingAddress,
  NeedShippingPackage,
  HasShippingPackage,
  HasShippingAddress,
  HasBillingAddress,
  ConfirmationInfoComplete,
  NeedsApproval
};
